export const scrollMainPanelToTop = () => {
  const rightPanel = document.getElementsByClassName('right-panel')[0]
  rightPanel.scrollTop = 0
}
